'use strict';

var $tulsaConfig = $('.tulsa-toggle-config');

module.exports = function () {
    $tulsaConfig.each(function () {
        let tulsaFlags = $(this).data('tulsa-flags');
        let classToHide = $(this).data('hidden-class');
        if (!tulsaFlags) {
            $('.' + classToHide).hide();
        }
    });
};

